import React from 'react';
import Result from 'models/Result';
import { Question } from 'models/Questionnaire';
import l10n from 'localization/LocalizationData';
import { PrintAnswerSectionField } from 'components/common/PrintAnswerSectionField';



export const ResultPrintView = React.forwardRef((props: { result: Result }, parentRef: any) => {
	const undecisive: Question[] = [];
	const helpNotWanted: Question[] = [];
	const helpWanted: Question[] = [];
	const highlighted: Question[] = [];

	props.result.questionnaire.questions.forEach((question, index) => {
		if (question.answer?.highlighted) {
			highlighted.push(question);
		}
		if (question.answer?.secondary === -1) {
			helpNotWanted.push(question);
		} else if (question.answer?.secondary === 0) {
			undecisive.push(question);
		} else if (question.answer?.secondary === 1) {
			helpWanted.push(question);
		}
	});

	return (
		<div aria-hidden='true' ref={parentRef} className='result-print only-print'>
			<div>
				<h2 className='mt-4'>{l10n.answers_target_title}</h2>
				{
					highlighted.length > 0 &&
					<PrintAnswerSectionField title='' answers={highlighted}/>
				}
			</div>
			<div className='print-answer-container'>
				<h2 className='my-4'>{l10n.answers_answers_title}</h2>
				{
					helpWanted.length > 0 &&
					<PrintAnswerSectionField title={l10n.answers_secondary_answer_Value_texts['1']} answers={helpWanted} />
				}
				{
					undecisive.length > 0 &&
					<PrintAnswerSectionField title={l10n.answers_secondary_answer_Value_texts['0']} answers={undecisive} />
				}
				{
					helpNotWanted.length > 0 &&
					<PrintAnswerSectionField title={l10n.answers_secondary_answer_Value_texts['-1']} answers={helpNotWanted} />
				}
			</div>
		</div>
	);
})